var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isSuperAdmin
      ? _c("div", [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "otp" } }, [_vm._v("Código OTP")]),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "numeric|required|min:4|max:6",
                      expression: "'numeric|required|min:4|max:6'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.otp,
                      expression: "otp"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "otp",
                    id: "otpSuperAdmin",
                    maxlength: "6",
                    placeholder: "OTP",
                    size: "small"
                  },
                  domProps: { value: _vm.otp },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.otp = $event.target.value
                    }
                  }
                }),
                _c(
                  "small",
                  {
                    staticClass: "form-text text-muted",
                    attrs: { id: "otpHelpSuperAdmin" }
                  },
                  [
                    _vm._v(
                      " * Son los seis números que te muestra el Google Authenticator. "
                    )
                  ]
                ),
                _vm.errors.has("otp")
                  ? _c(
                      "small",
                      {
                        staticClass: "form-text text-danger",
                        attrs: { id: "otpErrorSuperAdmin" }
                      },
                      [_vm._v(" *" + _vm._s(_vm.errors.first("otp")) + " ")]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "row mt-2 justify-content-end text-right" },
            [
              _c(
                "div",
                { staticClass: "col-md-7" },
                [
                  !_vm.sendingSign
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.signAndConfigure }
                        },
                        [_vm._v(" Activar Certificado ")]
                      )
                    : _vm._e(),
                  _vm.sendingSign
                    ? _c("b-spinner", {
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    !_vm.isSuperAdmin
      ? _c("div", [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col container-pdf" },
              _vm._l(_vm.numPages, function(i) {
                return _c("pdf", { key: i, attrs: { src: _vm.url, page: i } })
              }),
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "otp" } }, [_vm._v("Código OTP")]),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "numeric|required|min:4|max:6",
                      expression: "'numeric|required|min:4|max:6'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.otp,
                      expression: "otp"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "otp",
                    id: "otp",
                    maxlength: "6",
                    placeholder: "OTP",
                    size: "small"
                  },
                  domProps: { value: _vm.otp },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.otp = $event.target.value
                    }
                  }
                }),
                _c(
                  "small",
                  {
                    staticClass: "form-text text-muted",
                    attrs: { id: "otpHelp" }
                  },
                  [
                    _vm._v(
                      " * Son los seis números que te muestra el Google Authenticator. "
                    )
                  ]
                ),
                _vm.errors.has("otp")
                  ? _c(
                      "small",
                      {
                        staticClass: "form-text text-danger",
                        attrs: { id: "otpError" }
                      },
                      [_vm._v(" *" + _vm._s(_vm.errors.first("otp")) + " ")]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "row mt-2 justify-content-end text-right" },
            [
              _c("div", { staticClass: "3" }, [
                _c("div", { staticClass: "custom-control custom-checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmationRead,
                        expression: "confirmationRead"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "checkConfirmationRead" },
                    domProps: {
                      checked: Array.isArray(_vm.confirmationRead)
                        ? _vm._i(_vm.confirmationRead, null) > -1
                        : _vm.confirmationRead
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.confirmationRead,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.confirmationRead = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.confirmationRead = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.confirmationRead = $$c
                        }
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "checkConfirmationRead" }
                    },
                    [_vm._v(" HE LEIDO Y ACEPTO LAS CONDICIONES ")]
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-md-7" },
                [
                  !_vm.sendingSign
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled: !_vm.confirmationRead
                          },
                          on: { click: _vm.signAndConfigure }
                        },
                        [_vm._v(" Firmar Responsabilidad ")]
                      )
                    : _vm._e(),
                  _vm.sendingSign
                    ? _c("b-spinner", {
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }